import { shopAsset } from '@utils/utils-config'

import { MerchantProfile } from 'src/features/merchant/merchant-profile'

export function BeachChairStrandbutlerImprint() {
  return (
    <MerchantProfile
      merchant={{
        tradeName: 'Strandbutler',
        legalName: 'Strand & Mehr GmbH',
        image: {
          url: shopAsset('/images/strandbutler-impressum.png'),
          alt: 'Strandbutler',
        },
        vatId: 'DE338544284',
        legalForm: 'company',
        country: 'DE',
        city: '20097 Hamburg',
        street: 'Spaldingstraße 130',
        companyRegistrationNumber: 'HRB 166661',
      }}
    />
  )
}
